module.exports = __webpack_public_path__ + "packs/media/images/badges/narcisista-a3da5199ea2733018ac3a2488756d62b.png";